import React, { useContext, useEffect, useState } from "react";
import Form from "../../../components/form";
import { mergeParams } from "../../../helpers/helpers";
import api from "../../../services/api";
import AppContext from "../../../container/context";
import { CircularProgress } from "@mui/material";
import ActionTable from "../../../components/table/ActionTable";

export default function Lista({ history, location }) {
  const [comboEscolas, setComboEscolas] = useState([]);
  const [lista, setLista] = useState([]);
  const [dadosFiltros, setDadosFiltros] = useState(
    mergeParams({ nome: "", cpf: "", email: "", escola: "" }, location)
  );
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    carregarComboEscolas();

    if (
      dadosFiltros.nome ||
      dadosFiltros.cpf ||
      dadosFiltros.email ||
      dadosFiltros.escola
    ) {
      carregar();
    }
  }, []);

  const carregarComboEscolas = () => {
    api
      .get("escolas/listar", { ativas: true })
      .then((comboEscolas) => setComboEscolas(comboEscolas));
  };

  const carregar = (filtrosEnviar = dadosFiltros) => {
    setDadosFiltros(filtrosEnviar);
    setCarregando(true);
    filtrosEnviar.escola = !filtrosEnviar.escola ? "" : filtrosEnviar.escola;

    api
      .get("pais/listar", filtrosEnviar)
      .then((res) => {
        console.log("res", res);

        setLista(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível listar os pais");
        setCarregando(false);
      });
  };

  const filtros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Pai",
        type: "text",
        space: 6,
        value: dadosFiltros.nome,
      },
      cpf: {
        label: "CPF",
        type: "number",
        space: 6,
        value: dadosFiltros.cpf,
      },
      email: {
        label: "Email",
        type: "text",
        space: 6,
        value: dadosFiltros.email,
      },
      escola: {
        label: "Escola",
        type: "select",
        emptyItem: true,
        space: 6,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        value: dadosFiltros.escola,
      },
    },

    submit: {
      label: "Buscar",
      action: carregar,
    },

    urlParams: true,
    history,
    location,
  };

  const abrirPai = (registro) => {
    history.push(`/app/pai/${registro.id}`);
  };

  const tRegistros = {
    title: "Pais",
    onLineClick: abrirPai,
    newItemAction: () => history.push("/app/pai/0"),
    columns: [
      {
        name: "usuarioNome",
        label: "Nome",
      },
      {
        name: "usuarioCpf",
        label: "CPF",
      },
      {
        name: "usuarioEmail",
        label: "Email",
      },
      {
        name: "escolaNome",
        label: "Escola",
      },
    ],
    array: lista,
  };

  return (
    <div>
      <Form formData={filtros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
